import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";

export const webpayApi = createApi({
  reducerPath: "webpayApi",
  baseQuery: baseQuery(`${API_SERVER}/webpay`),
  endpoints: (builder) => ({
    /**
     * Inicia una transacción WebPay.
     * @param {{ idFactura: number, tipoFactura: 'PLAN'|'TAREA', amount: number, returnUrl: string }} body
     * @returns {{ token: string, url: string }}
     */
    crearTransaccion: builder.mutation({
      query: (body) => ({
        url: "/create",
        method: "POST",
        body,
      }),
    }),

    /**
     * Confirma una transacción WebPay (llamado cuando Transbank redirige de vuelta).
     * Acepta los 4 escenarios posibles:
     *  - Pago normal:   { token_ws }
     *  - Timeout:       { TBK_ORDEN_COMPRA, TBK_ID_SESION }
     *  - Cancelado:     { TBK_TOKEN }
     *  - Atípico:       { token_ws, TBK_TOKEN }
     * @returns {{ success: boolean, data: object, message: string }}
     */
    commitTransaccion: builder.mutation({
      query: (body) => ({
        url: "/commit",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useCrearTransaccionMutation, useCommitTransaccionMutation } =
  webpayApi;
